import {assert} from 'Asserts';
import {NumberIDFolder, StringIDFolder} from 'constants/FolderConstants';
import ModelTypeConstants, {StorableItemType} from 'constants/ModelTypeConstants';
import {Section} from 'constants/NavConstants';
import normalizeFolder from 'folders/util/normalizeFolder';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import {openListing} from 'nav/sidepanel/SidepanelReduxActions';
import {getStore} from 'redux-stores/Store';
import {Filter, FilterKey, keyToEmptyFilter, SortKey} from 'search/SearchConstants';

const FALLBACK_FILTER_STORABLE_TYPES = [
  ModelTypeConstants.BOX,
  ModelTypeConstants.CONTAINER,
  ModelTypeConstants.PLATE,
];

function getRegistryFilterList(folder: NumberIDFolder | StringIDFolder): Array<Filter> {
  if (!folder.source || folder.source.sourceType !== 'registry') {
    assert(false, 'Expected source to exist and be a registry');
    return [];
  }
  return [
    {
      ...keyToEmptyFilter(FilterKey.REGISTRY),
      value: folder.source.id,
    },
  ];
}

/**
 * Load a search for all storable items of type `modelType`, sorted so new items appear first.
 * Requires `folder.source` to exist and be a registry.
 */
export default function listRecentlyCreatedStorables(
  folder: NumberIDFolder | StringIDFolder,
  modelType: StorableItemType | 'transfer'
): void {
  const normalizedFolder = normalizeFolder(folder);
  getStore().dispatch(
    openListing(Section.STORAGE, {
      offset: 0,
      limit: getSelectedPageSize(),
      sorts: [{key: SortKey.SORT_CREATED_AT_KEY, reverse: true}],
      filters: [
        ...getRegistryFilterList(normalizedFolder),
        keyToEmptyFilter(FilterKey.ARCHIVE_PURPOSES),
        {
          ...keyToEmptyFilter(FilterKey.TYPES),
          value: modelType !== 'transfer' ? [modelType] : FALLBACK_FILTER_STORABLE_TYPES,
        },
      ],
      query: '',
    })
  );
}
